<template>
    <div id="view">
        <div class="box">
            <div id="title" class="title has-text-grey-dark"><i class="fa fa-bullhorn"></i> News</div>
        </div>
        <hr>
        <div class="box columns is-multiline">
            <div class="column is-12">
              <router-link v-bind:to="{name: 'add-news' }" class="button is-info is-pulled-right">Add new</router-link>
            </div>
            <div class="column">
                <news-table :page="page" @search="onSearch" @sort="onOrderBy" @pageChanged="onPageChanged" :total="total" v-bind:items="news" v-bind:actions="true"></news-table>
            </div>
        </div>          
    </div>  
</template>

<script>
import NewsRepo from '../../repos/NewsRepo'
import lodash from 'lodash'
import NewsTable from "./Table";

export default {
  name: 'news-view',
  components: {NewsTable},
  data() {
        return {
            repo: new NewsRepo(this.$auth),
            news: [],
            total: 0,
            q: '',
            orderBy: 'id,asc',
            page: 1,
        }
  },
  created(){
    this.getNews();
  },
  methods: {
    onSearch(q){
        this.page = 1;
        this.q = q;
        this.getNews();
    },
    onOrderBy(orderBy){
        this.page = 1;
        this.orderBy = orderBy;
        this.getNews();
    },
    onPageChanged(page){
        this.page = page;        
        this.getNews();
    },
    getNews(){
        this.repo.paginate(this.page, this.q, this.orderBy).then(response => {            
            this.news = response.data.data;
            this.total = response.data.meta.pagination.total_pages            
        });         
    },
  },
  watch: {
       
  }
  
}
</script>

<style lang="css" scoped>

</style>


// WEBPACK FOOTER //
// src/components/news/View.vue